import React from "react";
import { Form } from "antd";
import { useSelector } from "react-redux";
import FormModal from "components/Modal/FormModal";
import NatureOfVisitForm from "./NatureOfVisitForm";

const AddNatureOfVisit = () => {
  const CurdRProps = useSelector((state) => state.CurdR);
  const { Add_NatureOfVisit_Modal, Loader } = CurdRProps;

  const [form] = Form.useForm();
  return (
    <FormModal
      addButtonName="Add New"
      modalTitle="Add Nature Of Visit 1"
      submitButtonText="Save"
      cancelButtonText="Cancel"
      apiMethod="POST"
      addApiName="addNatureOfVisit"
      addApiRequest="AddRecord"
      apiLoader="StartSpinner"
      ModalName="Add_NatureOfVisit_Modal"
      confirmLoading={Loader}
      ModalType="Hide_Modal"
      visible={Add_NatureOfVisit_Modal ? Add_NatureOfVisit_Modal : false}
      width={550}
      form={form}
      className="doctor-profile-modal"
      recordName="natureOfVisitList"
    >
      <NatureOfVisitForm />
    </FormModal>
  );
};

export default AddNatureOfVisit;
